<template>
  <header class="AppHeader">
    <div class="header-wrapper">
      <div class="header-lf">
        <div class="logo hand" @click="clickLogo">
          <img class="logo-img" src="@/assets/images/sf-logo.png" alt="SF" />
        </div>
      </div>
      <a-menu v-model="selectedKeys" mode="horizontal" class="menu">
        <a-menu-item
          v-for="item in menuList"
          :class="item.key"
          :disabled="item.disabled"
          :key="item.key"
          @click.native="item.click"
        >
          {{ item.title }}
          <!-- <template v-if="item.key === 'store'">
            {{ item.title }}
          </template>
          <template v-else>
            <a >{{item.title}}</a>
          </template> -->
        </a-menu-item>
      </a-menu>
      <div class="block"></div>
      <div class="header-rt" v-if="mobile">
        <!-- <div class="menu-myorder" @click="toMyOrder">
          <img
            :src="require('@/assets/images/icon_myorder.svg')"
            class="icon-myorder"
            alt=""
          />
          <span>我的订单</span>
        </div> -->
        <a-dropdown
          :trigger="['click']"
          placement="bottomCenter"
          @command="onOptionChange"
        >
          <div class="lang-select">
            <div class="user-avator-box">
              <!-- <a-icon class="user-avator" type="user" /> -->
            </div>
            <div class="lang">
              <span class="content-top">个人中心</span>
            </div>
            <a-icon class="h-caret-down" type="caret-down" />
          </div>
          <a-menu slot="overlay" class="user-settting">
            <a-menu-item disabled class="drop-item-center">{{
              mobile
            }}</a-menu-item>
            <a-menu-divider />

            <a-menu-item class="drop-item" @click="toBAccountCenter"
              ><img
                :src="require('@/assets/images/icon_account_center.svg')"
                class="icon-myorder"
                alt=""
              />账号中心</a-menu-item
            >
            <a-menu-item class="drop-item" @click="toMyOrder"
              ><img
                :src="require('@/assets/images/icon_myorder_yixuan.svg')"
                class="icon-myorder"
                alt=""
              />我的订单</a-menu-item
            >
            <a-menu-item class="drop-item" @click="toInvoiced">
              <img
                :src="require('@/assets/images/fapiao_yixuan.svg')"
                class="icon-myorder"
                alt=""
              />开具发票</a-menu-item
            >
            <a-menu-item class="drop-item" @click="toContract">
              <img
                :src="require('@/assets/images/hetong_yixuan.svg')"
                class="icon-myorder"
                alt="" />我的合同<span
                class="contract-dot"
                v-if="isShowContractTips"
              ></span
            ></a-menu-item>
            <a-menu-divider />

            <!--退出登录-->
            <a-menu-item class="drop-item-center" @click="onLogout"
              >退出登录</a-menu-item
            >
          </a-menu>
        </a-dropdown>
      </div>
      <!-- <div class="header-rt" v-else>
        <a href="javascript:void(0);" class="a-login-sign">
          <button class="loginBtn signBtn" @click="onLogin">登录</button>
        </a>
      </div> -->
      <div class="header-rt no-login" v-else>
        <!-- 注册和登录 -->
        <!-- <a
          :href="`/sf/?switchTab=register&lang=zh-CN&it=${new Date().getTime()}`"
          class="a-login-sign"
        >
          <button class="signBtn btn-reset">注册</button></a
        > -->
        <a href="javascript:;" class="a-login-sign" @click="onLogin">
          <button class="loginBtn signBtn btn-reset">登录</button></a
        >
      </div>
    </div>
  </header>
</template>

<script>
import { userLogout } from "@/api/user.js";
import { contractTips } from "@/api/contract";
import { jumpBLogin, bLogout } from "@/utils/utils";
export default {
  name: "AppHeader",
  props: {
    // 手机号
    mobile: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowContractTips: false, // 是否有待签署合同
      menuList: [],
      selectedKeys: ["store"],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onOptionChange(command) {
      this[command]();
    },
    toBAccountCenter() {
      location.href = `${process.env.VUE_APP_B_ACCOUNT_DOMAIL}/accountCenter`;
    },
    toMyOrder() {
      this.$router.push({
        path: "/transaction/myorder",
      });
    },
    toInvoiced() {
      this.$router.push({
        path: "/invoice/notinvoicedorders",
      });
    },
    toContract() {
      this.$router.push({
        path: "/contract/mycontract",
      });
    },
    onLogout() {
      userLogout().then((res) => {
        let { success } = res;
        if (success) {
          this.$store.dispatch("storeVuex/logout", "");
          // 跳入B端退出登录
          bLogout();
          // this.$router.push({
          //   path: "/",
          // });
        }
      });
    },
    onLogin() {
      jumpBLogin();
      // this.$router.push({
      //   path: "/login",
      // });
    },
    // 退出登录
    async logout() {},
    // 点击logo
    clickLogo() {
      window.open("//v.sf-express.com");
    },
    initMenuList() {
      this.menuList = [
        {
          title: "物流中心",
          key: "admin",
          disabled: true,
          click: () => {
            window.open("//v.sf-express.com/web/laas/meta/logistics");
          },
        },
        {
          title: "商业服务",
          key: "service",
          disabled: true,
          click: () => {
            window.open("//v.sf-express.com/web/laas/service/business/index");
          },
        },
        {
          title: "开放平台",
          key: "open",
          disabled: true,
          click: () => {
            window.open("//open.sf-express.com/");
          },
        },
        // {
        //   title: "增值服务中心",
        //   key: "service",
        //   disabled: true,
        //   click: () => {
        //     window.open("//v.sf-express.com");
        //   },
        // },
        {
          title: "|",
          key: "br",
          disabled: true,
          click: () => {
            // window.open("//open.sf-express.com/");
          },
        },
        {
          title: "数字商店",
          key: "store",
          disabled: false,
          click: () => {
            this.$router.push({
              path: "/",
            });
          },
        },
      ];
    },
    // 待签署提醒
    async queryContractTips() {
      const { success, obj } = await contractTips();
      this.isShowContractTips = success && obj > 0;
    },
    init() {
      this.initMenuList();
    },
  },
  watch: {
    mobile(newVal) {
      if (newVal) this.queryContractTips();
    },
  },
};
</script>
<style lang="less">
.user-settting {
  min-width: 180px;
  border-radius: 3px;
  background: #ffffff;

  .drop-item {
    display: flex;
    padding-left: 28px;
    .img {
      padding-right: 15px;
    }
    &:hover {
      color: #66b1ff !important;
    }
  }
  .drop-item-center {
    text-align: center;
  }

  .contract-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: red;
  }
}
</style>
<style lang="less" scoped>
.menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #ffffff;
  &.span-item {
    color: rgba(190, 192, 231, 0.4);
  }
}

.menu-item-text {
  width: 56px;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

.AppHeader {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 100;
  user-select: none;
  .header-wrapper {
    width: 100%;
    height: 56px;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(32px);
    display: flex;
    justify-content: space-between;
  }

  .block {
    flex: 1;
  }

  .header-lf {
    display: flex;
    padding-left: 16px;
    align-items: center;
    flex-shrink: 0;

    .logo {
      .logo-img {
        height: 36px;
      }
    }
  }

  .menu {
    background: transparent;
    color: #fff;
    margin-left: 33px;
    &.ant-menu-horizontal {
      display: flex;
      line-height: 57px;
      border-bottom: none;
      .ant-menu-item {
        top: 0;
        height: 56px;
        padding: 0;
        margin: 0 15px;
        border-bottom: 4px solid transparent;
        line-height: 56px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        text-align: center;
        overflow: hidden;
        &:hover {
          border-bottom-color: transparent;
          color: #fff;
        }
        &.br {
          color: rgba(190, 192, 231, 0.4) !important;
          cursor: default;
        }
      }
      .ant-menu-item-selected {
        border-bottom: 4px solid rgb(212, 17, 35);
        color: #fff;
        font-weight: bold;
        &:hover {
          border-bottom: 4px solid rgb(212, 17, 35);
        }
      }
      .ant-menu-item-disabled {
        color: rgba(255, 255, 255, 0.8) !important;
        cursor: pointer;
      }
    }
  }

  .version-switch {
    font-size: 12px;
    color: #ffffff;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    opacity: 0.7;
    cursor: pointer;

    .change-img {
      width: 16px;
      height: 16px;
    }

    .use-text {
      line-height: 63px;
      font-size: 12px;
      font-weight: 400;
    }
  }

  .header-rt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding-right: 16px;
    .menu-myorder {
      margin-right: 16px;
      color: #ffffff;
      opacity: 0.8;
      cursor: pointer;
      .icon-myorder {
        display: inline-block;
        margin-right: 5px;
        margin-top: -2px;
      }
    }
    .lang-select {
      display: flex;
      align-items: center;
      padding: 0 16px;
      cursor: pointer;
      .check-card-icon {
        margin-right: 7px;
        transform: rotate(90deg);
      }
      .user-avator-box {
        width: 24px;
        height: 24px;
        margin-right: 5px;
        border-radius: 50%;
        background: url("~@/assets/images/avatar.png") no-repeat center center;
        background-size: 24px 24px;
        // background-image: linear-gradient(0deg, #eff0f4 0%, #bac4e0 100%);
        // opacity: 0.7;
        // text-align: center;
        // .user-avator {
        //   font-size: 16px;
        //   color: #141222;
        //   margin: auto;
        //   padding-top: 3px;
        // }
      }
      .lang {
        display: flex;
        flex-direction: column;
        margin-right: 8px;
        color: #fff;

        .content-top {
          font-size: 14px;
          font-weight: 500;
        }

        .tips-bottom {
          font-size: 10px;
          opacity: 0.7;
          margin-top: 1px;
          text-align: left;
          font-weight: 400;
        }
      }
      .h-caret-down {
        color: #fff;
      }
    }

    .user-settting {
      min-width: 100px;
    }
    // .a-login-sign {
    //   display: inline-block;
    //   background: transparent;
    //   .signBtn {
    //     cursor: pointer;
    //     background: transparent;
    //     font-size: 14px;
    //     line-height: 20px;
    //     color: #ffffff;
    //     text-align: center;
    //     width: 80px;
    //     height: 28px;
    //     border-radius: 0;
    //   }
    //   // .loginBtn {
    //   //   border: 1px solid #ffffff;
    //   // }
    // }
  }
}

.btn-reset {
  border: none;
  background: none;
  border-radius: 0;
  cursor: pointer;
}
.btn-reset:focus {
  outline: none;
}
.signBtn {
  height: 56px;
  line-height: 56px;
  padding: 0 30px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
}
.loginBtn {
  font-weight: 500;
  background-color: #db1a2c;
}
</style>

<style scoped>
@media screen and (max-width: 1200px) {
  .AppHeader .menu-item {
    margin-left: 14px;
    margin-right: 14px;
  }
  .AppHeader .menu {
    padding-left: 35px;
  }
}
@media screen and (max-width: 1040px) {
  .AppHeader .menu-item {
    margin-left: 8px;
    margin-right: 8px;
  }
  .AppHeader .header-rt {
    padding-left: 0;
  }
}
</style>
